<div class="mode-file-upload-dialog">
  <div class="title" mat-dialog-title>
    <mode-dialog-header [hideClose]="uploading">
      <h1 heading>{{ data.title }}</h1>
    </mode-dialog-header>
  </div>
  <div *ngIf="error" class="error-message">
    <capra-icon
      class="status-icon error"
      attr.data-test="capra-status-icon-error"
      icon="illo-error"
      width="18px"
      height="18px"
    ></capra-icon>
    <span class="error-message__text">{{ error }}</span>
  </div>

  <div mat-dialog-content class="mode-file-upload-dialog__content">
    <div *ngIf="uploading" class="notebook-upload-spinner">
      <div class="three-dot-spinner"><span></span><span></span><span></span></div>
      <div class="notebook-upload-spinner__message">Reading notebook cells</div>
    </div>
    <div [hidden]="uploading">
      <mode-file-upload
        [config]="data.config"
        [selectButtonText]="data.selectButtonText"
        [dragMessage]="data.dragMessage"
        [showMaxFileSize]="data.showMaxFileSize"
        [uploadIcon]="data.icon"
        [disabled]="uploading"
        (filesSelected)="onFilesSelected($event)"
        (fileRemoved)="onFileRemoved($event)"
        (validationErrorsChange)="onUploadError($event)"
      >
      </mode-file-upload>
    </div>
  </div>

  <div mat-dialog-actions class="mode-file-upload-dialog__actions">
    <capra-button
      class="cancel-btn"
      [text]="data.cancelButtonText"
      data-testid="file-upload-dialog-cancel"
      variant="secondary"
      color="neutral"
      modeTrackClick
      (clicked)="onCancel()"
      [disabled]="uploading"
    ></capra-button>
    <capra-button
      [text]="data.uploadButtonText"
      data-testid="file-upload-dialog-upload"
      modeTrackClick
      (clicked)="onUpload()"
      [disabled]="!hasFiles || uploading || hasValidationErrors"
    ></capra-button>
  </div>
</div>
